import React, { useState } from 'react'
import { useEffect } from 'react'
// import mData from '../PET_PARENT_TABLE_DATA.json'
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    getPaginationRowModel,
    getSortedRowModel,
    getFilteredRowModel
} from '@tanstack/react-table'
import { useMemo } from 'react'
import { Link } from 'react-router-dom';
import "../css/petParentTable.css"




function PetParentTable() {

    const [petData, setPetData] = useState([]);
  const fetchPetData = async ()=>{
    try {
        const response = await fetch(`https://petme.onrender.com/api/pets/findPet?verified=false`);
        const data = await response.json();
        setPetData(data)
    } catch (error) {
      console.log(error)
    }
  }  
  useEffect(() => {
    fetchPetData();
  }, []);

  const data = useMemo(() => petData.map((item, index) => ({ ...item, serial_no: index + 1 })), [petData]);  

    /** @type import('@tanstack/react-table').columnDef<any> */
    const columns = [

        {
            header: 'Serial No.',
            accessorKey: 'serial_no',
            // footer: 'Serial No.',
        },

        {
            header: 'ID',
            accessorKey: '_id',
        },


        {
            header: 'Full Name',
            accessorKey: 'ownername',
        },

        // {
        //     header: 'Last Name',
        //     accessorKey: 'last_name',
        // },

        {
            header: 'Email',
            accessorKey: 'email',
        },


        {
            header: 'Date Of Application',
            accessorKey: 'application_date',
        },

        // {
        //     header: 'Home Visit',
        //     accessorKey: 'home_visit',
        // },

        {
            header: 'Action',
            accessorKey: 'email',
            cell: (value) => (
                <Link to={`/petParentCard/${value.cell.row.original.email}`}>
                    <button className="parentTable-viewBtn">View</button>
                </Link>
            ),
        }
    ]

    const [sorting, setSorting] = useState([])
    const [filtering, setFiltering] = useState('')

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        //Show Limited Rows
        getPaginationRowModel: getPaginationRowModel(),
        // sort rows
        getSortedRowModel: getSortedRowModel(),
        // Filter Row--- Search in whole Table
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting: sorting,
            globalFilter: filtering
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setFiltering
    })

    return (

        <div className="w3-container">

            <h2 className="parentTable-heading">Pet Parent Table</h2>
            <input
                className="parentTable-filterInput"
                type="text" 
                placeholder='search here'
                value={filtering}
                onChange={(e) => setFiltering(e.target.value)}

            />

            <table className="w3-table-all">
                <thead>
                    {/* might have more than one haederGroup therefore, using getHeaderGroups */}
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id} onClick={header.column.getToggleSortingHandler()}>
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                    {
                                        { asc: <i class="parentTable-sortingArrow fa-solid fa-caret-up"></i>, desc: <i class="parentTable-sortingArrow fa-solid fa-caret-down"></i> }[
                                        header.column.getIsSorted() ?? null
                                        ]
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td>
                                    {flexRender(cell.column.columnDef.cell,
                                        cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>

                {/* <tfoot></tfoot> */}

            </table>

            <div className="parentTable-btnDiv">
                <button className="parentTable-btns" onClick={() => table.setPageIndex(0)}>First Page</button>
                <button className="parentTable-btns" disabled={!table.getCanPreviousPage()} onClick={() => table.previousPage()}>Previous</button>
                <button className="parentTable-btns" disabled={!table.getCanNextPage()} onClick={() => table.nextPage()}>Next</button>
                <button className="parentTable-btns" onClick={() => table.setPageIndex(table.getPageCount() - 1)}>Last Page</button>
            </div>

        </div>

    );
}


export default PetParentTable